import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["overlay"]

  connect() {
    this.showOverlay()
  }

  showOverlay() {
    this.overlayTarget.classList.remove("d-none")
  }

  hideOverlay() {
    this.overlayTarget.classList.add("d-none")
  }

  closeOnOutsideClick(event) {
    if (event.target == this.overlayTarget) {
      this.overlayTarget.classList.add("d-none")
    }
  }
}
